import '.e8{border-left:4px solid var(--gray-200);}.ssr-plugin'
import '.e9{padding-left:1.5rem;}.ssr-plugin'
import '.ea{margin:1rem 0;}.ssr-plugin'
import '.eb{color:var(--gray-700);}.ssr-plugin'
import '.ec{font-style:italic;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { PropsWithChildren } from 'react'

interface BlockQuoteProps extends PropsWithChildren {
  style?: Style
}

export const BlockQuote = ({ children, style }: BlockQuoteProps) => {
  return (
    <styled.blockquote className="e8 e9 ea eb ec"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.blockquote>
  )
}
